import actions from './actions';
import mutations from './mutations';

export default {
  state: {
    advertisers: [],
    advertisersWithBuyer: [],
    newAdvertiser: {}, // Used when creating new advertisers.
    uniqueAdvertisers: [],
    availableUniqueAdvertisers: [],
  },
  mutations,
  actions,
  getters: {
    uniqueAdvertisers: (state) => state.uniqueAdvertisers,
  },
};
